export const FormatsData: {[k: string]: SpeciesFormatsData} = {
	alakazammega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	arceus: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusbug: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusdragon: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusdark: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceuselectric: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusfairy: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusfire: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusfighting: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusflying: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusground: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusgrass: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusghost: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusice: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceuspsychic: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusrock: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceuspoison: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceuswater: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceussteel: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	blastoisemega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	blazikenmega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	calyrexice: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	calyrexshadow: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	cinderace: {
		tier: "UU",
		doublesTier: "DOU",
	},
	darkrai: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	darmanitangalar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	deoxysattack: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	deoxys: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	deoxysspeed: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	dialga: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	dracovish: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	dragapult: {
		tier: "OU",
		doublesTier: "DOU",
	},
	eternatus: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	genesect: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	gengarmega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	giratina: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	giratinaorigin: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	groudon: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	hooh: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	kangaskhanmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	kyogre: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	kyuremblack: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	kyuremwhite: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	landorus: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	lucariomega: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	lugia: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	lunala: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	magearna: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	marshadow: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	metagrossmega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	mewtwo: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	naganadel: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	mewtwomegax: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	mewtwomegay: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	necrozmadawnwings: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	necrozmaduskmane: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	necrozmaultra: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	palkia: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	pheromosa: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	rayquaza: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	rayquazamega: {
		tier: "AG",
		doublesTier: "DOU",
	},
	reshiram: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	salamencemega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	shayminsky: {
		tier: "UU",
		doublesTier: "DOU",
	},
	solgaleo: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	spectrier: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	tornadustherian: {
		tier: "OU",
		doublesTier: "DOU",
	},
	urshifu: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	xerneas: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	yveltal: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	zacian: {
		tier: "AG",
		doublesTier: "DOU",
	},
	zaciancrowned: {
		tier: "AG",
		doublesTier: "DOU",
	},
	zamazenta: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	zamazentacrowned: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	zekrom: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	zygarde: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	zygardecomplete: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	genesectburn: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	genesectshock: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	genesectchill: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	genesectdouse: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	groudonprimal: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	kyogreprimal: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	darmanitangalarzen: {
		tier: "OU",
		doublesTier: "DOU",
	},
	darmanitanzen: {
		tier: "UU",
		doublesTier: "DOU",
	},
	meloettapirouette: {
		tier: "UU",
		doublesTier: "DOU",
	},
	blissey: {
		tier: "OU",
		doublesTier: "DOU",
	},
	chansey: {
		tier: "UU",
		doublesTier: "DOU",
	},
	charizardmegax: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	charizardmegay: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	clefable: {
		tier: "OU",
		doublesTier: "DOU",
	},
	corviknight: {
		tier: "OU",
		doublesTier: "DOU",
	},
	excadrill: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ferrothorn: {
		tier: "OU",
		doublesTier: "DOU",
	},
	garchompmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	garchomp: {
		tier: "OU",
		doublesTier: "DOU",
	},
	gliscor: {
		tier: "OU",
		doublesTier: "DOU",
	},
	greninja: {
		tier: "UU",
		doublesTier: "DOU",
	},
	greninjaash: {
		tier: "OU",
		doublesTier: "DOU",
	},
	heatran: {
		tier: "OU",
		doublesTier: "DOU",
	},
	kartana: {
		tier: "OU",
		doublesTier: "DOU",
	},
	kommoo: {
		tier: "UU",
		doublesTier: "DOU",
	},
	kyurem: {
		tier: "OU",
		doublesTier: "DOU",
	},
	landorustherian: {
		tier: "OU",
		doublesTier: "DOU",
	},
	lopunnymega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	magnezone: {
		tier: "OU",
		doublesTier: "DOU",
	},
	mawilemega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	pelipper: {
		tier: "OU",
		doublesTier: "DOU",
	},
	rillaboom: {
		tier: "UU",
		doublesTier: "DOU",
	},
	scizormega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	serperior: {
		tier: "OU",
		doublesTier: "DOU",
	},
	slowbro: {
		tier: "OU",
		doublesTier: "DOU",
	},
	swampertmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	tapufini: {
		tier: "OU",
		doublesTier: "DOU",
	},
	tapukoko: {
		tier: "OU",
		doublesTier: "DOU",
	},
	tapulele: {
		tier: "OU",
		doublesTier: "DOU",
	},
	toxapex: {
		tier: "OU",
		doublesTier: "DOU",
	},
	tyranitar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tyranitarmega: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	victini: {
		tier: "OU",
		doublesTier: "DOU",
	},
	volcarona: {
		tier: "OU",
		doublesTier: "DOU",
	},
	weavile: {
		tier: "OU",
		doublesTier: "DOU",
	},
	zapdos: {
		tier: "OU",
		doublesTier: "DOU",
	},
	silvally: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallybug: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallydragon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallydark: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallyelectric: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallyfairy: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallyfire: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallyfighting: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallyflying: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallyground: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallygrass: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallyghost: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallyice: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallypsychic: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallyrock: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallypoison: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallywater: {
		tier: "RU",
		doublesTier: "DOU",
	},
	silvallysteel: {
		tier: "RU",
		doublesTier: "DOU",
	},
	aerodactylmega: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	alakazam: {
		tier: "UU",
		doublesTier: "DOU",
	},
	blacephalon: {
		tier: "OU",
		doublesTier: "DOU",
	},
	blaziken: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	dianciemega: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	gallademega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	gardevoirmega: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	gengar: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	gyarados: {
		tier: "UU",
		doublesTier: "DOU",
	},
	gyaradosmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	hawlucha: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	heracrossmega: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	hoopaunbound: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	hydreigon: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	jirachi: {
		tier: "UU",
		doublesTier: "DOU",
	},
	latias: {
		tier: "UU",
		doublesTier: "DOU",
	},
	latiasmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	latios: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	latiosmega: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	manaphy: {
		tier: "OU",
		doublesTier: "DOU",
	},
	medichammega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	melmetal: {
		tier: "OU",
		doublesTier: "DOU",
	},
	mew: {
		tier: "UU",
		doublesTier: "DOU",
	},
	moltresgalar: {
		tier: "OU",
		doublesTier: "DOU",
	},
	pinsirmega: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	sableye: {
		tier: "RU",
		doublesTier: "DOU",
	},
	slowbromega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	slowkinggalar: {
		tier: "OU",
		doublesTier: "DOU",
	},
	thundurus: {
		tier: "UU",
		doublesTier: "DOU",
	},
	thundurustherian: {
		tier: "UU",
		doublesTier: "DOU",
	},
	venusaurmega: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	xurkitree: {
		tier: "UU",
		doublesTier: "DOU",
	},
	zapdosgalar: {
		tier: "OU",
		doublesTier: "DOU",
	},
	aegislash: {
		tier: "UU",
		doublesTier: "DOU",
	},
	altariamega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	amoonguss: {
		tier: "UU",
		doublesTier: "DOU",
	},
	azumarill: {
		tier: "UU",
		doublesTier: "DOU",
	},
	beedrillmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	breloom: {
		tier: "UU",
		doublesTier: "DOU",
	},
	celesteela: {
		tier: "OU",
		doublesTier: "DOU",
	},
	chandelure: {
		tier: "UU",
		doublesTier: "DOU",
	},
	donphan: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dracozolt: {
		tier: "UU",
		doublesTier: "DOU",
	},
	dragonite: {
		tier: "UU",
		doublesTier: "DOU",
	},
	feraligatr: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gastrodon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hatterene: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hippowdon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	infernape: {
		tier: "UU",
		doublesTier: "DOU",
	},
	keldeo: {
		tier: "UU",
		doublesTier: "DOU",
	},
	keldeoresolute: {
		tier: "UU",
		doublesTier: "DOU",
	},
	krookodile: {
		tier: "UU",
		doublesTier: "DOU",
	},
	mamoswine: {
		tier: "UU",
		doublesTier: "DOU",
	},
	mandibuzz: {
		tier: "UU",
		doublesTier: "DOU",
	},
	manectricmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	mienshao: {
		tier: "UU",
		doublesTier: "DOU",
	},
	moltres: {
		tier: "RU",
		doublesTier: "DOU",
	},
	nidoking: {
		tier: "OU",
		doublesTier: "DOU",
	},
	nidoqueen: {
		tier: "UU",
		doublesTier: "DOU",
	},
	nihilego: {
		tier: "UU",
		doublesTier: "DOU",
	},
	quagsire: {
		tier: "UU",
		doublesTier: "DOU",
	},
	regieleki: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ribombee: {
		tier: "UU",
		doublesTier: "DOU",
	},
	rotomheat: {
		tier: "UU",
		doublesTier: "DOU",
	},
	rotomwash: {
		tier: "OU",
		doublesTier: "DOU",
	},
	salamence: {
		tier: "UU",
		doublesTier: "DOU",
	},
	scizor: {
		tier: "UU",
		doublesTier: "DOU",
	},
	skarmory: {
		tier: "UU",
		doublesTier: "DOU",
	},
	slowking: {
		tier: "UU",
		doublesTier: "DOU",
	},
	swampert: {
		tier: "UU",
		doublesTier: "DOU",
	},
	talonflame: {
		tier: "RU",
		doublesTier: "DOU",
	},
	tangrowth: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tornadus: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	umbreon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	urshifurapidstrike: {
		tier: "UU",
		doublesTier: "DOU",
	},
	abomasnow: {
		tier: "RU",
		doublesTier: "DOU",
	},
	abomasnowmega: {
		tier: "RU",
		doublesTier: "DOU",
	},
	absol: {
		tier: "RU",
		doublesTier: "DOU",
	},
	absolmega: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	aerodactyl: {
		tier: "RU",
		doublesTier: "DOU",
	},
	accelgor: {
		tier: "RU",
		doublesTier: "DOU",
	},
	aggron: {
		tier: "RU",
		doublesTier: "DOU",
	},
	aggronmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	alcremie: {
		tier: "RU",
		doublesTier: "DOU",
	},
	alomomola: {
		tier: "UU",
		doublesTier: "DOU",
	},
	altaria: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ambipom: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ampharos: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ampharosmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	appletun: {
		tier: "RU",
		doublesTier: "DOU",
	},
	araquanid: {
		tier: "RU",
		doublesTier: "DOU",
	},
	arbok: {
		tier: "RU",
		doublesTier: "DOU",
	},
	arcanine: {
		tier: "RU",
		doublesTier: "DOU",
	},
	archeops: {
		tier: "UU",
		doublesTier: "DOU",
	},
	arctovish: {
		tier: "RU",
		doublesTier: "DOU",
	},
	arctozolt: {
		tier: "OU",
		doublesTier: "DOU",
	},
	ariados: {
		tier: "RU",
		doublesTier: "DOU",
	},
	armaldo: {
		tier: "RU",
		doublesTier: "DOU",
	},
	aromatisse: {
		tier: "RU",
		doublesTier: "DOU",
	},
	articuno: {
		tier: "RU",
		doublesTier: "DOU",
	},
	articunogalar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	audino: {
		tier: "RU",
		doublesTier: "DOU",
	},
	audinomega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	aurorus: {
		tier: "RU",
		doublesTier: "DOU",
	},
	avalugg: {
		tier: "UU",
		doublesTier: "DOU",
	},
	azelf: {
		tier: "UU",
		doublesTier: "DOU",
	},
	banette: {
		tier: "RU",
		doublesTier: "DOU",
	},
	banettemega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	barbaracle: {
		tier: "RU",
		doublesTier: "DOU",
	},
	barraskewda: {
		tier: "UU",
		doublesTier: "DOU",
	},
	basculin: {
		tier: "RU",
		doublesTier: "DOU",
	},
	basculinbluestriped: {
		tier: "RU",
		doublesTier: "DOU",
	},
	bastiodon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	beautifly: {
		tier: "RU",
		doublesTier: "DOU",
	},
	beedrill: {
		tier: "RU",
		doublesTier: "DOU",
	},
	beheeyem: {
		tier: "RU",
		doublesTier: "DOU",
	},
	bellossom: {
		tier: "RU",
		doublesTier: "DOU",
	},
	bewear: {
		tier: "RU",
		doublesTier: "DOU",
	},
	bibarel: {
		tier: "RU",
		doublesTier: "DOU",
	},
	bisharp: {
		tier: "UU",
		doublesTier: "DOU",
	},
	blastoise: {
		tier: "RU",
		doublesTier: "DOU",
	},
	boltund: {
		tier: "RU",
		doublesTier: "DOU",
	},
	bouffalant: {
		tier: "RU",
		doublesTier: "DOU",
	},
	braviary: {
		tier: "RU",
		doublesTier: "DOU",
	},
	bronzong: {
		tier: "RU",
		doublesTier: "DOU",
	},
	bruxish: {
		tier: "RU",
		doublesTier: "DOU",
	},
	butterfree: {
		tier: "RU",
		doublesTier: "DOU",
	},
	buzzwole: {
		tier: "OU",
		doublesTier: "DOU",
	},
	cacturne: {
		tier: "RU",
		doublesTier: "DOU",
	},
	calyrex: {
		tier: "RU",
		doublesTier: "DOU",
	},
	camerupt: {
		tier: "RU",
		doublesTier: "DOU",
	},
	cameruptmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	carbink: {
		tier: "RU",
		doublesTier: "DOU",
	},
	carnivine: {
		tier: "RU",
		doublesTier: "DOU",
	},
	carracosta: {
		tier: "RU",
		doublesTier: "DOU",
	},
	castform: {
		tier: "RU",
		doublesTier: "DOU",
	},
	celebi: {
		tier: "RU",
		doublesTier: "DOU",
	},
	centiskorch: {
		tier: "UU",
		doublesTier: "DOU",
	},
	charizard: {
		tier: "RU",
		doublesTier: "DOU",
	},
	chatot: {
		tier: "RU",
		doublesTier: "DOU",
	},
	cherrim: {
		tier: "RU",
		doublesTier: "DOU",
	},
	chesnaught: {
		tier: "UU",
		doublesTier: "DOU",
	},
	chimecho: {
		tier: "RU",
		doublesTier: "DOU",
	},
	cinccino: {
		tier: "RU",
		doublesTier: "DOU",
	},
	clawitzer: {
		tier: "RU",
		doublesTier: "DOU",
	},
	claydol: {
		tier: "RU",
		doublesTier: "DOU",
	},
	cloyster: {
		tier: "RU",
		doublesTier: "DOU",
	},
	coalossal: {
		tier: "RU",
		doublesTier: "DOU",
	},
	cobalion: {
		tier: "UU",
		doublesTier: "DOU",
	},
	cofagrigus: {
		tier: "RU",
		doublesTier: "DOU",
	},
	comfey: {
		tier: "RU",
		doublesTier: "DOU",
	},
	conkeldurr: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	copperajah: {
		tier: "RU",
		doublesTier: "DOU",
	},
	corsola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	corsolagalar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	cursola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	crabominable: {
		tier: "RU",
		doublesTier: "DOU",
	},
	typenull: {
		tier: "RU",
		doublesTier: "DOU",
	},
	darmanitan: {
		tier: "UU",
		doublesTier: "DOU",
	},
	decidueye: {
		tier: "UU",
		doublesTier: "DOU",
	},
	dedenne: {
		tier: "RU",
		doublesTier: "DOU",
	},
	delcatty: {
		tier: "RU",
		doublesTier: "DOU",
	},
	delibird: {
		tier: "RU",
		doublesTier: "DOU",
	},
	delphox: {
		tier: "RU",
		doublesTier: "DOU",
	},
	deoxysdefense: {
		tier: "UU",
		doublesTier: "DOU",
	},
	dewgong: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dhelmise: {
		tier: "RU",
		doublesTier: "DOU",
	},
	diancie: {
		tier: "RU",
		doublesTier: "DOU",
	},
	diggersby: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ditto: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dodrio: {
		tier: "UU",
		doublesTier: "DOU",
	},
	dragalge: {
		tier: "RU",
		doublesTier: "DOU",
	},
	drampa: {
		tier: "RU",
		doublesTier: "DOU",
	},
	drapion: {
		tier: "RU",
		doublesTier: "DOU",
	},
	drednaw: {
		tier: "RU",
		doublesTier: "DOU",
	},
	drifblim: {
		tier: "RU",
		doublesTier: "DOU",
	},
	druddigon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dubwool: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dugtrio: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dugtrioalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dunsparce: {
		tier: "RU",
		doublesTier: "DOU",
	},
	duraludon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	durant: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	dusknoir: {
		tier: "UU",
		doublesTier: "DOU",
	},
	dustox: {
		tier: "RU",
		doublesTier: "DOU",
	},
	eelektross: {
		tier: "UU",
		doublesTier: "DOU",
	},
	eiscue: {
		tier: "RU",
		doublesTier: "DOU",
	},
	eldegoss: {
		tier: "RU",
		doublesTier: "DOU",
	},
	electivire: {
		tier: "RU",
		doublesTier: "DOU",
	},
	electrode: {
		tier: "RU",
		doublesTier: "DOU",
	},
	emboar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	emolga: {
		tier: "RU",
		doublesTier: "DOU",
	},
	empoleon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	entei: {
		tier: "RU",
		doublesTier: "DOU",
	},
	escavalier: {
		tier: "RU",
		doublesTier: "DOU",
	},
	espeon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	exeggutor: {
		tier: "RU",
		doublesTier: "DOU",
	},
	exeggutoralola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	exploud: {
		tier: "RU",
		doublesTier: "DOU",
	},
	falinks: {
		tier: "RU",
		doublesTier: "DOU",
	},
	farfetchd: {
		tier: "RU",
		doublesTier: "DOU",
	},
	farfetchdgalar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	fearow: {
		tier: "RU",
		doublesTier: "DOU",
	},
	flapple: {
		tier: "UU",
		doublesTier: "DOU",
	},
	flareon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	floatzel: {
		tier: "RU",
		doublesTier: "DOU",
	},
	florges: {
		tier: "UU",
		doublesTier: "DOU",
	},
	flygon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	forretress: {
		tier: "RU",
		doublesTier: "DOU",
	},
	froslass: {
		tier: "RU",
		doublesTier: "DOU",
	},
	frosmoth: {
		tier: "RU",
		doublesTier: "DOU",
	},
	furfrou: {
		tier: "RU",
		doublesTier: "DOU",
	},
	furret: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gallade: {
		tier: "RU",
		doublesTier: "DOU",
	},
	galvantula: {
		tier: "RU",
		doublesTier: "DOU",
	},
	garbodor: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gardevoir: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gigalith: {
		tier: "RU",
		doublesTier: "DOU",
	},
	girafarig: {
		tier: "RU",
		doublesTier: "DOU",
	},
	glaceon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	glalie: {
		tier: "RU",
		doublesTier: "DOU",
	},
	glaliemega: {
		tier: "RU",
		doublesTier: "DOU",
	},
	glastrier: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gogoat: {
		tier: "RU",
		doublesTier: "DOU",
	},
	golduck: {
		tier: "RU",
		doublesTier: "DOU",
	},
	golem: {
		tier: "RU",
		doublesTier: "DOU",
	},
	golemalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	golisopod: {
		tier: "RU",
		doublesTier: "DOU",
	},
	golurk: {
		tier: "RU",
		doublesTier: "DOU",
	},
	goodra: {
		tier: "UU",
		doublesTier: "DOU",
	},
	gorebyss: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gothitelle: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gourgeist: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gourgeistsmall: {
		tier: "OU",
		doublesTier: "DOU",
	},
	gourgeistlarge: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gourgeistsuper: {
		tier: "RU",
		doublesTier: "DOU",
	},
	granbull: {
		tier: "RU",
		doublesTier: "DOU",
	},
	grapploct: {
		tier: "RU",
		doublesTier: "DOU",
	},
	greedent: {
		tier: "RU",
		doublesTier: "DOU",
	},
	grimmsnarl: {
		tier: "RU",
		doublesTier: "DOU",
	},
	grumpig: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gumshoos: {
		tier: "RU",
		doublesTier: "DOU",
	},
	guzzlord: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hariyama: {
		tier: "UU",
		doublesTier: "DOU",
	},
	haxorus: {
		tier: "UU",
		doublesTier: "DOU",
	},
	heatmor: {
		tier: "RU",
		doublesTier: "DOU",
	},
	heliolisk: {
		tier: "RU",
		doublesTier: "DOU",
	},
	heracross: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	hitmonchan: {
		tier: "RU",
		doublesTier: "DOU",
	},
	hitmonlee: {
		tier: "RU",
		doublesTier: "DOU",
	},
	hitmontop: {
		tier: "RU",
		doublesTier: "DOU",
	},
	honchkrow: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hoopa: {
		tier: "RU",
		doublesTier: "DOU",
	},
	houndoommega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	houndoom: {
		tier: "RU",
		doublesTier: "DOU",
	},
	huntail: {
		tier: "RU",
		doublesTier: "DOU",
	},
	hypno: {
		tier: "RU",
		doublesTier: "DOU",
	},
	illumise: {
		tier: "RU",
		doublesTier: "DOU",
	},
	incineroar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	indeedee: {
		tier: "RU",
		doublesTier: "DOU",
	},
	indeedeef: {
		tier: "RU",
		doublesTier: "DOU",
	},
	inteleon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	jellicent: {
		tier: "RU",
		doublesTier: "DOU",
	},
	jolteon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	jumpluff: {
		tier: "RU",
		doublesTier: "DOU",
	},
	jynx: {
		tier: "RU",
		doublesTier: "DOU",
	},
	kabutops: {
		tier: "RU",
		doublesTier: "DOU",
	},
	kangaskhan: {
		tier: "RU",
		doublesTier: "DOU",
	},
	kecleon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	kingdra: {
		tier: "RU",
		doublesTier: "DOU",
	},
	kingler: {
		tier: "RU",
		doublesTier: "DOU",
	},
	klefki: {
		tier: "RU",
		doublesTier: "DOU",
	},
	klinklang: {
		tier: "RU",
		doublesTier: "DOU",
	},
	klang: {
		tier: "NFE",
		doublesTier: "DOU",
	},
	komala: {
		tier: "RU",
		doublesTier: "DOU",
	},
	kricketune: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lanturn: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lapras: {
		tier: "RU",
		doublesTier: "DOU",
	},
	leafeon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	leavanny: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ledian: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lickilicky: {
		tier: "RU",
		doublesTier: "DOU",
	},
	liepard: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lilligant: {
		tier: "RU",
		doublesTier: "DOU",
	},
	linoone: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lopunny: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lucario: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ludicolo: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lumineon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	lunatone: {
		tier: "RU",
		doublesTier: "DOU",
	},
	luvdisc: {
		tier: "RU",
		doublesTier: "DOU",
	},
	luxray: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lycanroc: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lycanrocdusk: {
		tier: "UU",
		doublesTier: "DOU",
	},
	lycanrocmidnight: {
		tier: "RU",
		doublesTier: "DOU",
	},
	machamp: {
		tier: "RU",
		doublesTier: "DOU",
	},
	magcargo: {
		tier: "RU",
		doublesTier: "DOU",
	},
	magmortar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	malamar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	manectric: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mantine: {
		tier: "RU",
		doublesTier: "DOU",
	},
	maractus: {
		tier: "RU",
		doublesTier: "DOU",
	},
	marowak: {
		tier: "UU",
		doublesTier: "DOU",
	},
	marowakalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	masquerain: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mawile: {
		tier: "RU",
		doublesTier: "DOU",
	},
	medicham: {
		tier: "RU",
		doublesTier: "DOU",
	},
	meganium: {
		tier: "RU",
		doublesTier: "DOU",
	},
	meloetta: {
		tier: "UU",
		doublesTier: "DOU",
	},
	meltan: {
		tier: "RU",
		doublesTier: "DOU",
	},
	meowstic: {
		tier: "RU",
		doublesTier: "DOU",
	},
	meowsticf: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mesprit: {
		tier: "UU",
		doublesTier: "DOU",
	},
	metagross: {
		tier: "UU",
		doublesTier: "DOU",
	},
	mightyena: {
		tier: "RU",
		doublesTier: "DOU",
	},
	milotic: {
		tier: "RU",
		doublesTier: "DOU",
	},
	miltank: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mimikyu: {
		tier: "UU",
		doublesTier: "DOU",
	},
	minior: {
		tier: "RU",
		doublesTier: "DOU",
	},
	minun: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mismagius: {
		tier: "RU",
		doublesTier: "DOU",
	},
	morpeko: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mothim: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mrmime: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mrrime: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mudsdale: {
		tier: "RU",
		doublesTier: "DOU",
	},
	muk: {
		tier: "UU",
		doublesTier: "DOU",
	},
	mukalola: {
		tier: "OU",
		doublesTier: "DOU",
	},
	musharna: {
		tier: "RU",
		doublesTier: "DOU",
	},
	necrozma: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	ninetales: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ninetalesalola: {
		tier: "OU",
		doublesTier: "DOU",
	},
	ninjask: {
		tier: "RU",
		doublesTier: "DOU",
	},
	noctowl: {
		tier: "RU",
		doublesTier: "DOU",
	},
	noivern: {
		tier: "RU",
		doublesTier: "DOU",
	},
	obstagoon: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	octillery: {
		tier: "RU",
		doublesTier: "DOU",
	},
	omastar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	oranguru: {
		tier: "RU",
		doublesTier: "DOU",
	},
	orbeetle: {
		tier: "RU",
		doublesTier: "DOU",
	},
	oricorio: {
		tier: "RU",
		doublesTier: "DOU",
	},
	oricoriopau: {
		tier: "RU",
		doublesTier: "DOU",
	},
	oricoriopompom: {
		tier: "RU",
		doublesTier: "DOU",
	},
	oricoriosensu: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pachirisu: {
		tier: "RU",
		doublesTier: "DOU",
	},
	palossand: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pangoro: {
		tier: "RU",
		doublesTier: "DOU",
	},
	parasect: {
		tier: "RU",
		doublesTier: "DOU",
	},
	passimian: {
		tier: "RU",
		doublesTier: "DOU",
	},
	perrserker: {
		tier: "RU",
		doublesTier: "DOU",
	},
	persian: {
		tier: "RU",
		doublesTier: "DOU",
	},
	persianalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	phione: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pidgeot: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pidgeotmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	pikachu: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachualola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachuhoenn: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachukalos: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachuoriginal: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachupartner: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachusinnoh: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachuunova: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachuworld: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pincurchin: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pinsir: {
		tier: "RU",
		doublesTier: "DOU",
	},
	plusle: {
		tier: "RU",
		doublesTier: "DOU",
	},
	politoed: {
		tier: "RU",
		doublesTier: "DOU",
	},
	poliwrath: {
		tier: "RU",
		doublesTier: "DOU",
	},
	polteageist: {
		tier: "UU",
		doublesTier: "DOU",
	},
	polteageistantique: {
		tier: "UU",
		doublesTier: "DOU",
	},
	porygonz: {
		tier: "UU",
		doublesTier: "DOU",
	},
	primarina: {
		tier: "UU",
		doublesTier: "DOU",
	},
	primeape: {
		tier: "RU",
		doublesTier: "DOU",
	},
	probopass: {
		tier: "RU",
		doublesTier: "DOU",
	},
	purugly: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pyroar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pyukumuku: {
		tier: "UU",
		doublesTier: "DOU",
	},
	qwilfish: {
		tier: "RU",
		doublesTier: "DOU",
	},
	raichu: {
		tier: "RU",
		doublesTier: "DOU",
	},
	raichualola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	raikou: {
		tier: "UU",
		doublesTier: "DOU",
	},
	rampardos: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ferroseed: {
		tier: "RU",
		doublesTier: "DOU",
	},
	rapidashgalar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	rapidash: {
		tier: "RU",
		doublesTier: "DOU",
	},
	raticate: {
		tier: "RU",
		doublesTier: "DOU",
	},
	raticatealola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	regice: {
		tier: "RU",
		doublesTier: "DOU",
	},
	regidrago: {
		tier: "RU",
		doublesTier: "DOU",
	},
	regigigas: {
		tier: "UU",
		doublesTier: "DOU",
	},
	regirock: {
		tier: "RU",
		doublesTier: "DOU",
	},
	registeel: {
		tier: "RU",
		doublesTier: "DOU",
	},
	reuniclus: {
		tier: "UU",
		doublesTier: "DOU",
	},
	rhyperior: {
		tier: "UU",
		doublesTier: "DOU",
	},
	roserade: {
		tier: "RU",
		doublesTier: "DOU",
	},
	rotom: {
		tier: "RU",
		doublesTier: "DOU",
	},
	rotomfan: {
		tier: "RU",
		doublesTier: "DOU",
	},
	rotommow: {
		tier: "UU",
		doublesTier: "DOU",
	},
	rotomfrost: {
		tier: "RU",
		doublesTier: "DOU",
	},
	runerigus: {
		tier: "UU",
		doublesTier: "DOU",
	},
	salazzle: {
		tier: "RU",
		doublesTier: "DOU",
	},
	samurott: {
		tier: "UU",
		doublesTier: "DOU",
	},
	sandaconda: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sandslash: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sandslashalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sawk: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sawsbuck: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sceptile: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sceptilemega: {
		tier: "RU",
		doublesTier: "DOU",
	},
	scolipede: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	scrafty: {
		tier: "RU",
		doublesTier: "DOU",
	},
	seaking: {
		tier: "RU",
		doublesTier: "DOU",
	},
	seismitoad: {
		tier: "RU",
		doublesTier: "DOU",
	},
	seviper: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sharpedo: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sharpedomega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	shaymin: {
		tier: "RU",
		doublesTier: "DOU",
	},
	shedinja: {
		tier: "UU",
		doublesTier: "DOU",
	},
	shiftry: {
		tier: "RU",
		doublesTier: "DOU",
	},
	shiinotic: {
		tier: "RU",
		doublesTier: "DOU",
	},
	shuckle: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sigilyph: {
		tier: "RU",
		doublesTier: "DOU",
	},
	simipour: {
		tier: "RU",
		doublesTier: "DOU",
	},
	simisage: {
		tier: "RU",
		doublesTier: "DOU",
	},
	simisear: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sirfetchd: {
		tier: "RU",
		doublesTier: "DOU",
	},
	skuntank: {
		tier: "RU",
		doublesTier: "DOU",
	},
	slaking: {
		tier: "RU",
		doublesTier: "DOU",
	},
	slowbrogalar: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	slurpuff: {
		tier: "RU",
		doublesTier: "DOU",
	},
	smeargle: {
		tier: "RU",
		doublesTier: "DOU",
	},
	snorlax: {
		tier: "RU",
		doublesTier: "DOU",
	},
	solrock: {
		tier: "RU",
		doublesTier: "DOU",
	},
	spinda: {
		tier: "RU",
		doublesTier: "DOU",
	},
	spiritomb: {
		tier: "RU",
		doublesTier: "DOU",
	},
	stakataka: {
		tier: "UU",
		doublesTier: "DOU",
	},
	stantler: {
		tier: "RU",
		doublesTier: "DOU",
	},
	staraptor: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	starmie: {
		tier: "UU",
		doublesTier: "DOU",
	},
	steelix: {
		tier: "RU",
		doublesTier: "DOU",
	},
	steelixmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	stonjourner: {
		tier: "RU",
		doublesTier: "DOU",
	},
	stoutland: {
		tier: "RU",
		doublesTier: "DOU",
	},
	stunfisk: {
		tier: "RU",
		doublesTier: "DOU",
	},
	stunfiskgalar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sudowoodo: {
		tier: "RU",
		doublesTier: "DOU",
	},
	suicune: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sunflora: {
		tier: "RU",
		doublesTier: "DOU",
	},
	swalot: {
		tier: "RU",
		doublesTier: "DOU",
	},
	swanna: {
		tier: "RU",
		doublesTier: "DOU",
	},
	swellow: {
		tier: "RU",
		doublesTier: "DOU",
	},
	swoobat: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sylveon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tapubulu: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tauros: {
		tier: "RU",
		doublesTier: "DOU",
	},
	tentacruel: {
		tier: "UU",
		doublesTier: "DOU",
	},
	terrakion: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	thievul: {
		tier: "RU",
		doublesTier: "DOU",
	},
	throh: {
		tier: "RU",
		doublesTier: "DOU",
	},
	togedemaru: {
		tier: "UU",
		doublesTier: "DOU",
	},
	togekiss: {
		tier: "RU",
		doublesTier: "DOU",
	},
	torkoal: {
		tier: "UU",
		doublesTier: "DOU",
	},
	torterra: {
		tier: "RU",
		doublesTier: "DOU",
	},
	toucannon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	toxicroak: {
		tier: "RU",
		doublesTier: "DOU",
	},
	toxtricity: {
		tier: "RU",
		doublesTier: "DOU",
	},
	toxtricitylowkey: {
		tier: "RU",
		doublesTier: "DOU",
	},
	trevenant: {
		tier: "RU",
		doublesTier: "DOU",
	},
	tropius: {
		tier: "RU",
		doublesTier: "DOU",
	},
	tsareena: {
		tier: "RU",
		doublesTier: "DOU",
	},
	turtonator: {
		tier: "RU",
		doublesTier: "DOU",
	},
	typhlosion: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tyrantrum: {
		tier: "RU",
		doublesTier: "DOU",
	},
	unfezant: {
		tier: "RU",
		doublesTier: "DOU",
	},
	unown: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ursaring: {
		tier: "RU",
		doublesTier: "DOU",
	},
	uxie: {
		tier: "UU",
		doublesTier: "DOU",
	},
	vanilluxe: {
		tier: "RU",
		doublesTier: "DOU",
	},
	vaporeon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	venomoth: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	venusaur: {
		tier: "UU",
		doublesTier: "DOU",
	},
	vespiquen: {
		tier: "RU",
		doublesTier: "DOU",
	},
	victreebel: {
		tier: "RU",
		doublesTier: "DOU",
	},
	vikavolt: {
		tier: "RU",
		doublesTier: "DOU",
	},
	vileplume: {
		tier: "RU",
		doublesTier: "DOU",
	},
	virizion: {
		tier: "RU",
		doublesTier: "DOU",
	},
	vivillon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	volbeat: {
		tier: "RU",
		doublesTier: "DOU",
	},
	volcanion: {
		tier: "OU",
		doublesTier: "DOU",
	},
	wailord: {
		tier: "RU",
		doublesTier: "DOU",
	},
	vivillonfancy: {
		tier: "RU",
		doublesTier: "DOU",
	},
	vivillonpokeball: {
		tier: "RU",
		doublesTier: "DOU",
	},
	walrein: {
		tier: "RU",
		doublesTier: "DOU",
	},
	watchog: {
		tier: "RU",
		doublesTier: "DOU",
	},
	weezing: {
		tier: "RU",
		doublesTier: "DOU",
	},
	weezinggalar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	whimsicott: {
		tier: "RU",
		doublesTier: "DOU",
	},
	whiscash: {
		tier: "RU",
		doublesTier: "DOU",
	},
	wigglytuff: {
		tier: "RU",
		doublesTier: "DOU",
	},
	wishiwashi: {
		tier: "OU",
		doublesTier: "DOU",
	},
	wormadam: {
		tier: "RU",
		doublesTier: "DOU",
	},
	wormadamsandy: {
		tier: "UU",
		doublesTier: "DOU",
	},
	wormadamtrash: {
		tier: "RU",
		doublesTier: "DOU",
	},
	xatu: {
		tier: "RU",
		doublesTier: "DOU",
	},
	yanmega: {
		tier: "RU",
		doublesTier: "DOU",
	},
	zangoose: {
		tier: "RU",
		doublesTier: "DOU",
	},
	zarude: {
		tier: "UU",
		doublesTier: "DOU",
	},
	zarudedada: {
		tier: "OU",
		doublesTier: "DOU",
	},
	zeraora: {
		tier: "OU",
		doublesTier: "DOU",
	},
	zoroark: {
		tier: "RU",
		doublesTier: "DOU",
	},
	zygarde10: {
		tier: "UU",
		doublesTier: "DOU",
	},
	porygon2: {
		tier: "RU",
		doublesTier: "DOU",
	},
	crawdaunt: {
		tier: "UU",
		doublesTier: "DOU",
	},
	cresselia: {
		tier: "OU",
		doublesTier: "DOU",
	},
	doublade: {
		tier: "UU",
		doublesTier: "DOU",
	},
	magneton: {
		tier: "UU",
		doublesTier: "DOU",
	},
	scyther: {
		tier: "RU",
		doublesTier: "DOU",
	},
	beartic: {
		tier: "RU",
		doublesTier: "DOU",
	},
	cradily: {
		tier: "RU",
		doublesTier: "DOU",
	},
	cramorant: {
		tier: "RU",
		doublesTier: "DOU",
	},
	crustle: {
		tier: "RU",
		doublesTier: "DOU",
	},
	cryogonal: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lurantis: {
		tier: "RU",
		doublesTier: "DOU",
	},
	relicanth: {
		tier: "RU",
		doublesTier: "DOU",
	},
	wobbuffet: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sandshrewalola: {
		tier: "LC",
		doublesTier: "DOU",
	},
	zebstrika: {
		tier: "RU",
		doublesTier: "DOU",
	},
	clamperl: {
		tier: "LC",
		doublesTier: "DOU",
	},
	sableyemega: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	sneasel: {
		tier: "RU",
		doublesTier: "DOU",
	},
	crobat: {
		tier: "RU",
		doublesTier: "DOU",
	},
};
